import api, {getAuthToken, normalizeApiError} from "../../system/api";
import {getStorage, getUser} from "../../system/storage";

export const AI_ERROR_CODES = {
    SUPPORT_RUNTIME_DISABLED: "support-ai-customer-runtime-disabled",
    NO_WORKSPACE: "AI_NO_WORKSPACE",
};

const waitForWorkspace = () => new Promise((resolve) => {
    const resolveWhenReady = () => {
        const workspaceId = getStorage("workspace");
        if (!workspaceId) return;
        window.removeEventListener("storage", resolveWhenReady);
        resolve(workspaceId);
    };

    window.addEventListener("storage", resolveWhenReady);
    resolveWhenReady();
});

export default class Ai {
    constructor(workspaceId) {
        this.workspaceId = workspaceId;
    }

    getHeader(workspaceId) {
        const wsId = workspaceId || this.workspaceId || getStorage("workspace");
        const user = getUser();
        const token = getAuthToken(user);
        return {
            headers: {
                ...(wsId ? {workspace: wsId} : {}),
                ...(token ? {Authorization: `Bearer ${token}`} : {}),
            },
        };
    }

    async chat({workspaceId, message}) {
        let wsId = workspaceId || this.workspaceId || getStorage("workspace");
        if (!wsId) wsId = await waitForWorkspace();
        if (!wsId) {
            const error = new Error(AI_ERROR_CODES.NO_WORKSPACE);
            error.code = AI_ERROR_CODES.NO_WORKSPACE;
            throw error;
        }
        try {
            const res = await api.post("/ai/chat", {message, workspaceId: wsId}, this.getHeader(wsId));
            return res.data;
        } catch (error) {
            throw error?.response?.data || error?.normalizedError || normalizeApiError(error);
        }
    }
}
